<!DOCTYPE html>
<img src="../../../assets/icon/iclose.svg" (click)="close()" class="close md-none" alt="" />
<div class="modal-container">
  <!--Start gursewak's Code date: 14-11-2022 : social benefits  -->

  <!-- Aman : last modified with vip status data binding on 15th Nov 2022  -->
  <img src="../../../assets/icon/iclose.svg" (click)="close()" class="close xs-none" alt="" />
  @if (cardData$ | async; as card) {
    <div class="top-border silver"></div>
    <div class="modal-card">
      <img
        onError="this.src='../../../assets/icon/silver.svg'"
        src="{{ card?.vip_status == currentVIPStatus ? card?.active_card : card?.inactive_card }}"
        alt=""
        class="card-img"
        />
        <!-- <img src="../../../assets/icon/silver-info.svg" alt="" class="icon"> -->
        <!-- <img src="{{card?.badge}}" onError="this.src='../../../assets/icon/silver-crown-svg.svg'" alt="" class="crown-svg"> -->
        <div class="status-div">
          <p>{{"homePage.VIP_status" | translate}}:</p>
          <h1>{{ card?.vip_status == currentVIPStatus ? ("homePage.Active" | translate) : ("homePage.inactive" | translate)}}</h1>
        </div>
        <div class="cards">
          <p class="card-type">{{ card?.name | uppercase }}</p>
        </div>
      </div>
      <div class="modal-header">
        <a class="next-link" (click)="socialBenefitDialog(isCurrentCard)">
          {{ isCurrentCard ? ("homePage.next_card" | translate) : ("homePage.Previous_card" | translate)}}
        </a>
        <h2>{{card?.content?.[languageCode]?.title}}</h2>
        <p>{{card?.content?.[languageCode]?.subtitle}}</p>
      </div>
      <div class="modal-content">
        @for (status of card?.content?.[languageCode]?.benefits; track status; let i = $index) {
          <div>
            <mat-accordion>
              <mat-expansion-panel
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
                hideToggle
                [disabled]="status?.locked"
                >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span class="title-img"
                      ><img
                      class="pad-lock"
                      [src]="status?.locked ? status.padlock_url : '../../../assets/icon/down.svg'"
                      alt="lock-image"
                      />
                      {{ status?.name ? status?.name : "NA" }}</span
                      >
                      <span class="title-value">{{ status?.quantity ? status?.quantity : "NA" }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <p>{{ status?.description ? status?.description : "NA" }}</p>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          }
        </div>
      }
    </div>

    <!--End gursewak's Code date: 14-11-2022 : social benefits  -->
